import { truncateLabel } from '@jane/shared-ecomm/util';
import type { Store } from '@jane/shared/types';

import { capitalize } from '../capitalize/capitalize';

interface CustomLineageLabelArgs {
  lineage: string;
  store: Store;
}
export const customLineageLabel = ({
  store,
  lineage,
}: CustomLineageLabelArgs) => {
  const customLabel = store.custom_lineage_labels?.[lineage]
    ? capitalize(store.custom_lineage_labels?.[lineage])
    : null;

  return customLabel ? truncateLabel(customLabel, 10) : capitalize(lineage);
};
